// extracted by mini-css-extract-plugin
module.exports = {"container":"H1FzRBuA","containerSp":"_23nd3zKg","imgWrapper":"_24uAUghV","photo":"_3-Pm_vWH","title":"BLUJrRoF","subText":"_1dSfAaqo","content":"_3QMW3M7H","name":"_3XX3ZZcO"};